import { render, staticRenderFns } from "./KioskBookingStatus.vue?vue&type=template&id=26c00519&"
import script from "./KioskBookingStatus.vue?vue&type=script&lang=js&"
export * from "./KioskBookingStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports